import { MuvenRoleEnum } from "@c2b/muven-commons"

export class UserAuthenticatedModel {
    id?:string|number = undefined
    name:string = '' // full name 
    username:string = ''    
    email:string = ''    
    givenName: string = ''
    familyName: string = ''
    phoneNumber:string = ''
    roles: MuvenRoleEnum[] = []

    constructor(u?:Partial<UserAuthenticatedModel>) {
        Object.assign(this, u)
    }

    setRoles(roles: MuvenRoleEnum[]):void {
        this.roles = roles;
    }

    isAdmin():boolean {
        for (const role of this.roles) {
            if (role === MuvenRoleEnum.administrator) {
                return true
            }
        }

        return false
    }

    isSponsor():boolean {
        for (const role of this.roles) {
            if (role === MuvenRoleEnum.sponsor) {
                return true
            }
        }

        return false
    }

    isImpersonate():boolean {
        for (const role of this.roles) {
            if (role === MuvenRoleEnum.impersonate) {
                return true
            }
        }

        return false
    }

    isValid():boolean {
        return !!this.givenName &&
            !!this.familyName &&
            (!this.phoneNumber || (!!this.phoneNumber && this.phoneNumber.length === 15)) // 15 = phoneNumber with mask (##) #####-####
    }
}
